import axios from 'axios';
import type { QuoteRejectReason } from 'src/ts';

export const getQuoteRejectReasonsService = async (): Promise<QuoteRejectReason[]> => {
  try {
    const response = await axios.get<QuoteRejectReason[]>('/patients/get-quote-reject-reason');
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};
